
import { checkIds, deleteAll, deleteById, getAll, getAllByMovieId, getAllWithinTimeFrame, getAllWithinTimeFrameByTheater, getByFormatsWithinTimeFrame, getByIds, getByMovieId, put, updateById, updateFilmFormat } from './showtimesMethods';

export const supabaseShowTimesInit = (supabase) => { return {
  getByIds: getByIds.bind(this, supabase),
  getByMovieId: getByMovieId.bind(this, supabase),
  getAllByMovieId: getAllByMovieId.bind(this, supabase),
  checkIds: checkIds.bind(this, supabase),
  getAll: getAll.bind(this, supabase),
  put: put.bind(this, supabase),
  updateById: updateById.bind(this, supabase),
  updateFilmFormat: updateFilmFormat.bind(this, supabase),
  deleteById: deleteById.bind(this, supabase),
  deleteAll: deleteAll.bind(this, supabase),
  getAllWithinTimeFrame: getAllWithinTimeFrame.bind(this, supabase),
  getAllWithinTimeFrameByTheater: getAllWithinTimeFrameByTheater.bind(this, supabase),
  getByFormatsWithinTimeFrame: getByFormatsWithinTimeFrame.bind(this, supabase),
}}